/* [PATCH aplikacije-fe v1] Kontekst aktivne aplikacije (localStorage + dogodek) in pravice iz GET /aplikacije/moje. */
import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { APLIKACIJE, AplikacijaId, preberiAplikacijo, shraniAplikacijo, smerAplikacije, opisAplikacije } from '../aplikacije';

export function useAplikacija() {
  const [aplikacija, setApl] = useState<AplikacijaId | null>(() => preberiAplikacijo());
  useEffect(() => {
    const h = () => setApl(preberiAplikacijo());
    window.addEventListener('aicount-aplikacija', h);
    window.addEventListener('storage', h);
    return () => { window.removeEventListener('aicount-aplikacija', h); window.removeEventListener('storage', h); };
  }, []);
  const izberi = useCallback((id: AplikacijaId) => { shraniAplikacijo(id); setApl(id); }, []);
  const pocisti = useCallback(() => { shraniAplikacijo(null); setApl(null); }, []);
  return { aplikacija, opis: opisAplikacije(aplikacija), smer: smerAplikacije(aplikacija), izberi, pocisti };
}

export interface MojaAplikacija { id: AplikacijaId; naziv: string; aktivna: boolean; dovoljena: boolean; podjetje: boolean; uporabnik: boolean; vidna?: boolean } // [PATCH pravice-app-podjetje v1] vidna
export interface MojeAplikacije {
  aplikacije: MojaAplikacija[];
  vloga: string | null;
  superadmin: boolean;
  upravlja_aplikacije: boolean;
  stevilo_podjetij: number;
  user_id: string;
  podjetja_po_aplikaciji?: Record<string, string[]>; // [PATCH pravice-app-podjetje v1]
}

/** Pravice uporabnika; `dovoljene` = ID-ji, v katere sme (v vrstnem redu vstopne strani). */
export function useMojeAplikacije() {
  const [podatki, setPodatki] = useState<MojeAplikacije | null>(null);
  const [napaka, setNapaka] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const nalozi = useCallback(() => {
    setLoading(true); setNapaka(null);
    api.get('/aplikacije/moje')
      .then((r: any) => setPodatki(r.data))
      .catch((e: any) => setNapaka(e?.response?.data?.detail || 'Napaka pri nalaganju aplikacij'))
      .finally(() => setLoading(false));
  }, []);
  useEffect(nalozi, [nalozi]);
  const dovoljeneSet = new Set((podatki?.aplikacije || []).filter((a) => a.dovoljena).map((a) => a.id));
  const dovoljene = APLIKACIJE.filter((a) => dovoljeneSet.has(a.id)).map((a) => a.id);
  /* [PATCH pravice-app-podjetje v1] vidne = aplikacije z vsaj enim podjetjem (tudi »Kmalu«); ostale vstopna stran skrije */
  const vidneSet = new Set((podatki?.aplikacije || []).filter((a) => a.vidna ?? (a.dovoljena || !a.aktivna)).map((a) => a.id));
  const vidne = APLIKACIJE.filter((a) => vidneSet.has(a.id)).map((a) => a.id);
  return { podatki, loading, napaka, dovoljene, vidne, ponovno: nalozi };
}
